import { render, staticRenderFns } from "./App.vue?vue&type=template&id=af041cc8&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.9.3_babel-core@7.0.0-bridge.0_@babel+core@7.11.1__cache-loader@4.1.0_webp_557f249d63f04d171c78492ef715bea7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/.pnpm/vuetify-loader@1.6.0_vue-template-compiler@2.6.11_vuetify@2.3.8_vue@2.6.11__webpack@4.47.0/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideYTransition})
